import React, { useEffect, useState } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import loadConfig from "../../../Services/apiService";

import { useDispatch, useSelector } from "react-redux";
import UpdateAcknowledgement from "../../../Services/Acknowledgement/UpdateAcknowledgement";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import {
  GetAC_FindOutAwardById,
  SetFindOutAward,
  UpdateAC_findOutAward,
} from "../../../Redux/Reducers/FindOutAward";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { GetAC_findOutAwardNames } from "../../../Redux/Reducers/DropDownApplicationInformation";

function FindOutAwardPage() {
  const AppGuid = useParams();
  //   const [pledgeText, setPledgeText] = useState("");
  const [jsonFile, setJsonFile] = useState();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      FindOutAward: state.FindOutAward.FindOutAward,
      AC_findOutAwardNames:state.dropDownApplicationInformation.AC_findOutAwardNames,
      ValidateAllPages: state.ValidateAllPages.ValidateAllPages, // Validation data for all pages
      loadingFindOutAward: state.FindOutAward.loadingFindOutAward,
      ActiveRound: state.ApplicationInformation.ActiveRound,

    };
  });
  const [findOutList, setfindOutList] = useState({ ...state.FindOutAward });
  const dataJson = async () => {
    let jsonData = await loadConfig();
    setJsonFile(jsonData);
  };
  useEffect(() => {
    dataJson();
  }, []);

  useEffect(() => {
    dispatch(GetAC_findOutAwardNames())
    dispatch(
      GetAC_FindOutAwardById(
        localStorage.getItem("aI_ApplicationInformationId") ||
          decryptToken(AppGuid.AppGuid)
      )
    );
  }, []);

  //[,]
  //to asssigin data after loading end
  useEffect(() => {
    if (state.loadingFindOutAward && state.FindOutAward) {
      setfindOutList({ ...state.FindOutAward });
    }
  }, [state.loadingFindOutAward]);

//   useEffect(() => {
//     dispatch(SetFindOutAward({ ...findOutList }));
//   }, [findOutList]);

  const updateFindUot=async(model)=>{
   await dispatch(UpdateAC_findOutAward({...model}));

  }
  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
  return jsonFile && state.FindOutAward ? (
    <>
      <SharedDiv
        showTitle={true}
        titleName="كيف تعرفت على الجائزة"
        child={[
          <div className="form-grid" key="">
            <AllDropDownsAHSF
              fieldsName="findOutName"
              show={true}
              disabled={shouldDisableFields}
              // showValidationMessage={true}
              // validationMessage="يرجى تعبئة هذا الحقل"
              onChange={(e) => {
                setfindOutList({
                    ...findOutList,
                    aC_findOutAwardNamesId: e.target.value,
                  });
                updateFindUot({
                    aC_findOutAwardId: state.FindOutAward?.aC_findOutAwardId,
                    aC_findOutAwardNamesId: e.target.value,
                    aI_ApplicationInformationId: state.FindOutAward?.aI_ApplicationInformationId,
                  })
              }}
              defaultValue={state.FindOutAward?.aC_findOutAwardNamesId}
              arrayOoptionList={state.AC_findOutAwardNames}
              KeyText={"findOutName"}
              KeyValue={"aC_findOutAwardNamesId"}
              dropdownType={"normal"}
            //   showValidationMessage={
            //     state.ValidateAllPages
            //       ? state.ValidateAllPages.includes(
            //           "findOutName"
            //         )
            //       : false
            //   }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>,
        ]}
      />
    </>
  ) : (
    ""
  );
}

export default FindOutAwardPage;
